var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("radio-button-row", {
        key: _vm.externalServicesChanged,
        attrs: {
          title:
            "AidTargetYearlyReport.ExternalServices.AcquisitionsMadeOrExternalServicesUsed",
          required: true
        },
        model: {
          value: _vm.externalServices.acquisitionsMadeOrExternalServicesUsed,
          callback: function($$v) {
            _vm.$set(
              _vm.externalServices,
              "acquisitionsMadeOrExternalServicesUsed",
              $$v
            )
          },
          expression: "externalServices.acquisitionsMadeOrExternalServicesUsed"
        }
      }),
      _vm._v(" "),
      _vm.externalServices.acquisitionsMadeOrExternalServicesUsed
        ? _c(
            "div",
            [
              _c(
                "h3",
                { staticClass: "mb-3" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "AidTargetYearlyReport.ExternalServices.AcquisitionsAndExternalServices"
                        )
                      ) +
                      "\n      "
                  ),
                  _c("tooltip-icon", {
                    attrs: {
                      content: _vm.$t(
                        "AidTargetYearlyReport.ExternalServices.AcquisitionsAndExternalServices_Instructions"
                      )
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.acquisitionsAndServices, function(
                acquisitionOrService,
                index
              ) {
                return _c(
                  "div",
                  { staticClass: "group-wrapper mb-3" },
                  [
                    _c("div", { staticClass: "heading-div" }, [
                      _c(
                        "span",
                        { attrs: { id: "externalservices_" + index } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "AidTargetYearlyReport.ExternalServices.AcquisitionOrService"
                              )
                            ) +
                              " " +
                              _vm._s(index + 1)
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.acquisitionsAndServices.length > 1 && !_vm.isReadOnly
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "header-row-button btn btn-link btn-contrast float-right",
                              attrs: {
                                type: "button",
                                "aria-label":
                                  _vm.$t(
                                    "AidTargetYearlyReport.ExternalServices.DeleteItem"
                                  ) +
                                  " " +
                                  (index + 1) +
                                  " " +
                                  _vm.$t(
                                    "Accessibility.ConfirmDeleteAcquisitionOrService"
                                  )
                              },
                              on: {
                                click: function($event) {
                                  return _vm.deleteItem(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-trash-alt fa-lg" })]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("acquisition-or-service-control", {
                      attrs: { item: acquisitionOrService, index: index }
                    })
                  ],
                  1
                )
              }),
              _vm._v(" "),
              !_vm.isReadOnly
                ? _c("div", { staticClass: "mt-3" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: {
                          type: "button",
                          disabled: _vm.isAddNewItemDisabled,
                          "aria-disabled": _vm.isAddNewItemDisabled
                        },
                        on: {
                          click: function($event) {
                            return _vm.addNewExternalService(true)
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "AidTargetYearlyReport.ExternalServices.AddNew"
                            )
                          )
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }